import React from "react";
import { PublisherAdvancedFilters } from "@seabrookstudios/pitch2table-core";
import { useMakeListAndDetail, useMakeListBuilder } from "../core/useMakeLayout";
import { NoItemsFound } from "../publisher/NoItemsFound";
import Alert from "@mui/material/Alert";
import { MyPublisherDetailFromRoute } from "./MyPublisherDetailFromRoute";
import { MergedPublisherListEntry } from "./ListItem";
import { useMergedPublishers } from "./use-merged-publishers";

const NoPublishersFound = () => (
  <NoItemsFound>
    <Alert severity="info">
      Each publisher that you have some relationship with will show here. At the moment this is every publisher that you
      have shortlisted for a pitch.
    </Alert>
  </NoItemsFound>
);

export const PublishersListAndDetail = () => {
  /**
   * @param {import("@seabrookstudios/pitch2table-core").PublisherWithContactBookPublisher} item
   */
  const mergedIdExtractor = (item) => item[0].id.toString();

  const useMakeList = useMakeListBuilder(
    MergedPublisherListEntry,
    mergedIdExtractor,
    "Publishers",
    NoPublishersFound,
    undefined
  );

  const ListAndDetail = useMakeListAndDetail(
    useMergedPublishers,
    [],
    "publishers",
    useMakeList,
    MyPublisherDetailFromRoute,
    PublisherAdvancedFilters
  );

  return <ListAndDetail />;
};
